<template>
  <DropdownSelect
      :label="label"
      :modelValue="modelValue"
      :options="getStatusOptions"
      :maxTextLength="maxTextLength"
      @update:modelValue="$emit('update:modelValue', $event)"
  />
</template>

<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import DropdownSelect from './DropdownSelect.vue';

const { t } = useI18n();

const props = defineProps({
  label: {
    type: String,
    default: ''
  },
  modelValue: {
    type: [String, Number],
    default: 2
  },
  maxTextLength: {
    type: Number,
    default: 12
  },
  tabType: {
    type: String,
    default: 'general'
  }
});

const emit = defineEmits(['update:modelValue']);

const getStatusOptions = computed(() => {
  const optionsByType = {
    'test': [
      { value: 2, label: t('allTests') },
      { value: 1, label: t('published') },
      { value: 0, label: t('draft') }
    ],
    'program': [
      { value: 2, label: t('allPrograms') },
      { value: 1, label: t('published') },
      { value: 0, label: t('draft') }
    ],
    'user': [
      { value: 2, label: t('allUsers') },
      { value: 1, label: t('active') },
      { value: 0, label: t('passive') }
    ],
    'gameLabs': [
      { value: 2, label: t('allGameLabs') },
      { value: 1, label: t('active') },
      { value: 0, label: t('passive') }
    ]
  };

  return optionsByType[props.tabType] || [
    { value: 2, label: t('allStatuses') },
    { value: 1, label: t('active') },
    { value: 0, label: t('passive') }
  ];
});
</script>
